import { ReactElement } from 'react';

import { Button, ButtonVariant } from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

type PatientDataAccessDownloadHistoryButtonProps = {
   readonly onClick: VoidFunction;
};

export const PatientDataAccessDownloadHistoryButton = (
   props: PatientDataAccessDownloadHistoryButtonProps
): ReactElement => {
   return (
      <Button
         testId={'downloadPrescriptionsHistory'}
         label={prescriptionsHistoryDownloadTranslationKeys.downloadPrescriptionsHistory}
         onClick={props.onClick}
         variant={ButtonVariant.PRIMARY}
      />
   );
};
